<template>
  <!-- <div class="login-page">
    <el-row>
      <el-col :span="16">
      </el-col :span="8">
          <div class="login">
      <el-form ref="form" :rules="rules" class="login-form" :model="formData" label-width="80px" @submit="onSubmit">
        <el-form-item label="用戶名" prop="username">
          <el-input v-model.trim="formData.username" placeholder="wisdom"></el-input>
        </el-form-item>
        <el-form-item label="密碼" prop="password">
          <el-input v-model.trim="formData.password" placeholder="108108"></el-input>
        </el-form-item>
        <el-form-item label="驗證碼" prop="code">
          <el-col :span="17">
            <el-input v-model.trim="formData.code"></el-input>
          </el-col>
          <el-col :span="7">
            <div class="captcha" @click="getCaptcha">{{captcha}}</div>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit" :loading="loading">登錄</el-button>
        </el-form-item>
      </el-form>
    </div>
      <el-col>
        
      </el-col>
    </el-row>

  </div>-->

  	<div class="bg">
		<div class="bg-container">
		    <video playsinline controls muted loop poster="../assets/img/videocover.jpg" class="video-container">
			<source src="../assets/img/promovide.mp4" type="video/mp4">
			</video>
			<form class="login-form" ref="loginForm" @submit="onSubmit" label-width="80px">
				<div class="input-username-container">
					<input v-model.trim="form.username" type="text" autocomplete="off" placeholder="wisdom" class="input-username">
					<p class="username-prompt">Please enter "wisdom" (lowercase)</p>
				</div>
				<div class="input-password-container">
					<input v-model.trim="form.password" type="password" autocomplete="off" placeholder="108108" class="input-password">
					<p class="password-prompt">Please enter "108108"</p>
				</div>
                <button class="submit-button" type="submit">
					<span style="font-size:16px;">登錄</span>
				</button>
				<!--<button class="submit-button" type="submit" native-type="submit" :loading="loading">
					<span style="font-size:16px;">登錄</span>
				</button>-->
			</form>
			</div>
	</div>
</template>

<script>
  import api from '../services/api'

  export default {
  data() {
  return {
  //loading: false,
  //captcha: '',
  form: {
  username: '',
  password: '',
  code: '1234'
  },
  rules: {
  username: [
  { required: true, message: '請輸入用戶名', trigger: 'change' }
  ],
  password: [
  { required: true, message: '請輸入密碼', trigger: 'change' }
  ]
  //code: [
  //{ required: true, message: '請輸入驗證碼', trigger: 'change' },
  //{
  //trigger: 'blur',
  //validator: (rule, value, callback) => {
  //if (value != this.captcha) {
  //callback(new Error('驗證碼錯誤'))
  //} else {
  //callback()
  //}
  //}
  //}
  //],
  }
  }
  },
  methods: {
  onSubmit(e) {
  e.preventDefault()
  console.log(e)
  //this.$refs.form.validate((valid) => {
  //const { username, password, code } = this.formData
  const {username, password, code} = this.form
  if (username == 'wisdom' && password == '108108') {
  //this.loading = true
  console.log(username)
  console.log(password)
  api.login({
  user: username,
  password,
  captcha: code
  }).then(() => {
  console.log("logged in")
  localStorage.user = 'wisdom'
  console.log(this.$route.query.url)
  if (this.$route.query.url) {
  this.$router.replace(this.$route.query.url)
  } else {
  console.log("Changing route to home")
  this.$router.replace({ name: 'Home' })
  console.log("CHanged route to home")
  }
  }).finally(() => {
  console.log("End of process")
  //this.loading = false
  })
  }
  //})
  },
  //getCaptcha() {
  //api.getCaptcha().then(res => {
  //this.captcha = res.captcha
  //})
  //}
  },
  beforeRouteEnter (to, from, next) {
  console.log("before routing away")
  if (localStorage.user) {
  console.log("before using next to home")
  next({ name: 'Home' })
  } else {
  console.log("before using next ")
  next()
  }
  },
  created() {
  console.log("created")
  //this.getCaptcha()
  }
  }
</script>
<style lang="less" scoped>
    .bg{
        position: absolute;
        width: 100%;
        //background: #f5f6f7;
        left: 0;
        top:0;
        right: 0;
        bottom: 0;
        background: url('../assets/img/homepagebg.jpg');
        background-size: cover;
        background-repeat: repeat-y;
        //z-index: 0;

        //width: 100vw;
        //height: 100vh;
        //background: url('../assets/img/homepagebg.jpg') no-repeat;
        //background-position: top center;
        //background-size: cover;

        .bg-container{
            position: relative; z-index: 0; width: 100vw; height: auto; text-align: center; top: calc(100vh - 62vh);


            .video-container{
                width:auto; height: 36vh;
            }

            .login-form{
                width: 100%; height: auto; position: relative; z-index: 1; bottom:calc(100vh - 101vh); color: #eee;

                .input-username-container{
                    position: absolute; z-index: 8;  left: calc(100vh - 36vh);

                    .input-username{
                        border-radius: 8px; width: calc(100vw - 84vw); height: 36px; border:1px solid #666; padding-left:12px; color: #333; font-size: 14px;
                    }

                    .username-prompt{
                        margin: 0; font-size: 12px; text-align: left; text-indent:14px; line-height: 24px; text-transform:uppercase;
                    }
                }

                .input-password-container{
                    position: absolute; z-index: 10; right: calc(100vh - 36vh);

                    .input-password{
                        border-radius: 8px; width: calc(100vw - 84vw); height: 36px; border:1px solid #666; padding-left:12px; color: #333; font-size: 14px;
                    }

                    .password-prompt{
                        margin: 0; font-size: 12px; text-align: left; text-indent:14px; line-height: 24px; text-transform:uppercase;
                    }
                }

                .submit-button{
                    position: absolute;
                    top: 80px;
                    padding: 12px 0;
                    border-radius: 6px;
                    background: #00d0d8;
                    color: #fff;
                    border: 0;
                    left: calc(100% - 54%);
                    right: 0;
                    z-index: 12;
                    width: 8vw;
                    cursor: pointer;
                }
            }
        }
    }
</style>
